import { render, staticRenderFns } from "./studentRegisterTalentIndustry.vue?vue&type=template&id=8ae292a2&scoped=true"
import script from "./studentRegisterTalentIndustry.vue?vue&type=script&lang=js"
export * from "./studentRegisterTalentIndustry.vue?vue&type=script&lang=js"
import style0 from "./studentRegisterTalentIndustry.vue?vue&type=style&index=0&id=8ae292a2&prod&scoped=true&lang=css"
import style1 from "./studentRegisterTalentIndustry.vue?vue&type=style&index=1&id=8ae292a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae292a2",
  null
  
)

export default component.exports